import './App.css';
import AboutMePage from './Pages/AboutMePage';


function App() {
  return (
    <div className="App">
      <AboutMePage />
    </div>
  );
}

export default App;
